import React from "react";
import { DateDisplay } from "../DateDisplay";
import { FeatureToggle } from "../../models/FeatureToggles";
import { ValueDisplayProps } from "../ValueDisplay";
import { GridValueDisplayList } from "../GridValueDisplayList";

interface FeatureToggleDetailsProps {
	featureToggle: FeatureToggle;
}

/**
 * Display a feature toggle
 * @param props
 */
export const FeatureToggleDetails = (props: FeatureToggleDetailsProps) => {
	const data = props.featureToggle;

	const detailsToDisplay: ValueDisplayProps[] = [
		{
			label: "Name",
			node: data.name,
		},
		{
			label: "Display name",
			node: data.displayName,
		},
		{
			label: "Deployment ring",
			node: data.deploymentRing.name,
		},
		{
			label: "Created on",
			node: <DateDisplay date={data.created} />,
		},
		{
			label: "Created by",
			node: data.createdBy,
		},
		{
			label: "Updated on",
			node: <DateDisplay date={data.updated} />,
		},
		{
			label: "Updated by",
			node: data.lastUpdatedBy,
		},
		{
			label: "Product tiers",
			node: data.productTierNames,
		},
	];

	return <GridValueDisplayList displayItems={detailsToDisplay}></GridValueDisplayList>;
};
